import React from 'react';
import './EmptyState.css';

/**
 * Shared EmptyState component.
 *
 * Props:
 *   icon      – optional JSX for the icon. Defaults to a music-note SVG.
 *   title     – headline text. Defaults to "No results found".
 *   subtitle  – supporting body copy. Defaults to a generic suggestion.
 *   hasSearch – when true, copies reflect "no match" rather than "empty list".
 */
function EmptyState({
  icon,
  title,
  subtitle,
  hasSearch = false,
}) {
  const defaultTitle = hasSearch ? 'No results found' : 'Nothing here yet';
  const defaultSubtitle = hasSearch
    ? 'Try adjusting your search, sort, or filter criteria.'
    : 'Add a new record to get started.';

  return (
    <div className="empty-state-wrapper">
      <div className="empty-state-icon-box">
        {icon || (
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            aria-hidden="true"
          >
            <path d="M9 18V5l12-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="16" r="3" />
          </svg>
        )}
      </div>

      <h3 className="empty-state-title">{title || defaultTitle}</h3>
      <p className="empty-state-subtitle">{subtitle || defaultSubtitle}</p>
    </div>
  );
}

export default EmptyState;
